import { CarrierAccount } from "@redotech/redo-model/carrier-account/carrier-account";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getCarrierAccounts = {
  name: "getCarrierAccounts" as const,
  input: zNull(),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
    // Per-team Sendcloud BYOA flag (default OFF). Drives whether the merchant
    // UI offers Sendcloud as an addable carrier.
    sendcloudByoaEnabled: z.boolean(),
  }),
};
